import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Link, useHistory, useLocation,
} from 'react-router-dom';
import { desfazerCidade, selectCidade } from '../../app/slices/cidadesSlice';
import { desfazerConexao, selectLogin, fetchLoginAnonimo } from '../../app/slices/loginSlice';
import {
  abrirModalContato, abrirModalEnquete, abrirModalEscolhaLoginTotem, abrirModalLogin, abrirModalTotemLogin, selectModal,
} from '../../app/slices/modalSlice';
import { desfazerSecretaria } from '../../app/slices/secretariasSlice';
import LogoImg from '../../assets/icons/logo.png';
import { ReactComponent as CartaSvg } from '../../assets/icons/menu/carta.svg';
import { ReactComponent as EnqueteSvg } from '../../assets/icons/menu/enquete.svg';
import { ReactComponent as GraficosSvg } from '../../assets/icons/menu/graficos.svg';
import { ReactComponent as LoginSvg } from '../../assets/icons/menu/login.svg';
import { ReactComponent as LogoutSvg } from '../../assets/icons/menu/logout.svg';
import { ReactComponent as ManifestacaoSvg } from '../../assets/icons/menu/manifestacao.svg';
import { ReactComponent as OuvidoriaSvg } from '../../assets/icons/menu/ouvidoria.svg';
import { ReactComponent as SicSvg } from '../../assets/icons/menu/sic.svg';
import { ReactComponent as TelefonesSvg } from '../../assets/icons/menu/telefones.svg';
import { ReactComponent as UsuarioSvg } from '../../assets/icons/menu/usuario.svg';
import { ReactComponent as ConselhoSvg } from '../../assets/icons/menu/conselho.svg';
import { ReactComponent as ServicosSvg } from '../../assets/icons/menu/servicos.svg';
import { ReactComponent as ZeladoriaSvg } from '../../assets/icons/menu/zeladoria.svg';
import { ReactComponent as TotemSvg } from '../../assets/icons/totemSvg.svg';
import LogoWebnets from '../../assets/images/logo-webnets.png';
import Logo1Doc from '../../assets/images/logo-1doc.png';
import LogoInterTec from '../../assets/images/logo-inter-tec.png';
import LogoPrescon from '../../assets/images/logo-prescon.png';
import LogoEl from '../../assets/images/logo-el-rgb.png';
import { Linha, Logotipo, NomeCidade } from '../../styles/base';
import {
  setAuthToken, getIdCidadeEcrie, setTotem, getTotem, getIdCidadeEsipe,
} from '../../api/apiFactory';
import BotaoMenu from '../BotaoMenu/BotaoMenu';
import {
  Header, Menu, MenuFooter, MenuHeader, MenuItem, LinkHeader,
} from './AppHeaderEstilo';
import {
  fetchLimparCookie, fectchConselhoMunicipal, fetchSolicitanteSic, fetchNomeCidade, fetchContatos, fetchEnquetesPergunta, fetchSecretarias3,
} from '../../api/endpoints';

const cor = {
  graficos: {
    letra: '#f7c63a',
    fundo: 'rgba(251,226,157,0.1)',
  },
  manifestacao: {
    letra: '#5a7ab7',
    fundo: 'rgba(90,122,183,0.1)',
  },
  ouvidoria: {
    letra: '#22aa91',
    fundo: 'rgba(0,204,0,0.1)',
  },
  sic: {
    letra: '#9b5ada',
    fundo: 'rgba(155,90,218,0.1)',
  },
  enquete: {
    letra: '#c4566a',
    fundo: 'rgba(196,86,106,0.1)',
  },
  cadastro: {
    letra: '#f56f3a',
    fundo: 'rgba(245,111,58,0.1)',
  },
  login: {
    letra: '#e29400',
    fundo: 'rgba(226,148,0,0.1)',
  },
  sair: {
    letra: '#b1205b',
    fundo: 'rgba(177,32,91,0.1)',
  },
};

const AppHeader = ({ onClick }) => {
  const [menuAberto, setMenuAberto] = useState(false);
  const [membroConselho, setMembroConselho] = useState('N');
  const [nomeCidade, setNomeCidade] = useState();
  const dadosCidade = useSelector(selectCidade);
  const dadosLogin = useSelector(selectLogin);
  const dadosModal = useSelector(selectModal);
  const [temEnquete, setTemEnquete] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const [listaContatos, setListaContatos] = useState(null);

  // Será utilizado para testar se existe alguma secretaria disponível para zeladoria.
  // Pois há casos em que a cidade usa a zeladoria, mas suas secretarias são apenas internas, e portanto ao clicar no módulo no site, não aparecem opções de secretarias.
  // Então dito isso, é melhor ocultar o menu caso não haja nenhuma secretaria disponível.
  const [listaSecretariasZeladoria, setListaSecretariasZeladoria] = useState(null);

  const { search } = useLocation();

  useEffect(() => {
    fetchNomeCidade().then((response) => setNomeCidade(response));
    Promise.all([
      fetchContatos(),
      fetchSecretarias3(),
    ]).then(([dadosContatos, dadosSecretariasZeladoria]) => {
      setListaContatos(dadosContatos);
      setListaSecretariasZeladoria(dadosSecretariasZeladoria);
    });
    if (search && search.includes('totem=true')) {
      setTotem(true);
    }
    if (search && search.includes('totem=false')) {
      setTotem(false);
    }

    if ((dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppEnquete === 'S') && (dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo')) {
      fetchEnquetesPergunta().then((response) => {
        if (response && response.Message && response.Message !== 'Nenhum registro foi encontrado.') {
          setTemEnquete(true);
        } else {
          setTemEnquete(false);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') {
      fectchConselhoMunicipal().then((response) => setMembroConselho(response.Message));
    }
  }, [dadosLogin]);

  const logaAnonimoAcompanhamento = async () => {
    if (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') {
      history.push('/acompanhamentos');
      return;
    }

    await dispatch(await fetchLoginAnonimo({
      modulo: 'o',
    }));
    history.push('/acompanhamentos');
  };

  const limpaLoginAnonimo = (data) => {
    if (data && data.data && data.data.anonimo === 'anonimo') {
      setAuthToken(null);
      dispatch(desfazerConexao());
    }
  };

  window.onresize = () => {
    if (window.innerWidth > 800 && menuAberto === false) {
      setMenuAberto(true);
    }

    if (window.innerWidth < 801 && menuAberto === true) {
      setMenuAberto(false);
    }
  };

  const handleTotem = () => {
    setTotem(true);
    setTimeout(() => {
      history.push('/totem');
    }, 10);
  };

  return (
    <Header totem={getTotem() === 'true'} desfoque={dadosModal.desfoque} className="controle-fundo">
      <nav>
        <Menu>
          <MenuHeader>
            <Linha totem={getTotem() === 'true'}>
              <LinkHeader to="/">
                {(getTotem() === 'true') ? (
                  <img src={LogoImg} style={{ marginTop: '20', width: 50, height: 50 }} alt="Logo eOuve - Sistema de Ouvidoria" />
                ) : (
                  <img src={LogoImg} style={{ marginTop: '20' }} alt="Logo eOuve - Sistema de Ouvidoria" />
                )}

                <span>
                  {dadosCidade.data
                    ? (
                      <>
                        {(getTotem() === 'true') ? (<small style={{ fontSize: 17 }}>eOuve</small>) : (<small>eOuve</small>)}
                        <NomeCidade totem={getTotem() === 'true'}>{dadosCidade.data.nomeCidade}</NomeCidade>
                      </>
                    )
                    : (
                      <Logotipo>eOuve</Logotipo>
                    )}
                </span>
              </LinkHeader>
              {dadosCidade.data
                && (<BotaoMenu aberto={menuAberto} onClick={() => setMenuAberto(!menuAberto)} />)}
            </Linha>
          </MenuHeader>
          {((window.innerWidth > 800) || (menuAberto === true && window.innerWidth < 801)) && (
            <>
              {dadosCidade && dadosCidade.data && (
                <div>
                  {((dadosCidade && dadosCidade.configuracoes) && (
                    ((dadosCidade.configuracoes.OcultarAnonimoSic === 'S' || dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoSic === 'S') && dadosCidade.configuracoes.OcultarAppSic === 'S')
                    || ((dadosCidade.configuracoes.OcultarAnonimoZeladoria === 'S' || dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoZeladoria === 'S') && dadosCidade.configuracoes.OcultarAppZeladoria === 'S')
                    || dadosCidade.configuracoes.OcultarAnonimoAcompanhamentoOuvidoria === 'S'
                    || dadosCidade.configuracoes.OcultarAnonimoOuvidoria === 'S'
                    || dadosCidade.configuracoes.AcompanhamentoAnonimo === 'S'
                    || (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo')
                  )
                    && (dadosCidade.configuracoes.AcompanhamentoAnonimo === 'S' || (dadosCidade.configuracoes.AcompanhamentoAnonimo === 'N' && (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo')))) && (
                      <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                        <Link
                          to="#"
                          onClick={() => {
                            logaAnonimoAcompanhamento();
                          }}
                        >
                          <ManifestacaoSvg />
                          <span>Acompanhamentos</span>
                        </Link>
                      </MenuItem>
                  )}

                  {dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.CartaDeServicos && getTotem() !== 'true' ? (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="/cartadeservicos" onClick={() => dispatch(desfazerSecretaria())}>
                        <CartaSvg />
                        <span>Carta de Serviços</span>
                      </Link>
                    </MenuItem>
                  ) : null}

                  {(listaContatos && listaContatos[0]
                  && (
                    listaContatos[0].Email01
                    || listaContatos[0].Endereco01
                    || listaContatos[0].Telefone01
                    || listaContatos[0].NomeOuvidor
                    || listaContatos[0].HorarioFuncionamentoDe01
                    || listaContatos[0].HorarioFuncionamentoDe02
                  )
                  && (getTotem() !== 'true')) && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="#" onClick={() => dispatch(abrirModalContato())}>
                        <TelefonesSvg />
                        <span>Contatos</span>
                      </Link>
                    </MenuItem>
                  )}

                  {((dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') && (membroConselho === 'S') && (getTotem() !== 'true')) && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="/conselhomunicipal">
                        <ConselhoSvg />
                        <span>Conselho de Usuários</span>
                      </Link>
                    </MenuItem>
                  )}

                  {((!temEnquete) && (dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppEnquete === 'S') && (dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') && (getTotem() !== 'true')) && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="/enquetes">
                        <EnqueteSvg />
                        <span>Enquete</span>
                      </Link>
                    </MenuItem>
                  )}

                  {getTotem() !== 'true' && dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade
                  && !dadosCidade.data.nomeCidade.toLowerCase().includes('juiz de fora')
                  && !dadosCidade.data.nomeCidade.toLowerCase().includes('cincatarina') && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="/graficos" onClick={onClick}>
                        <GraficosSvg />
                        <span>Gráficos</span>
                      </Link>
                    </MenuItem>
                  )}

                  {(dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo') && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="/conta" onClick={() => dispatch(desfazerSecretaria())}>
                        <UsuarioSvg />
                        <span>Meu cadastro</span>
                      </Link>
                    </MenuItem>
                  )}

                  {(!dadosLogin.data || (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo && dadosLogin.data.anonimo !== 'naoanonimo')) && (getTotem() !== 'true') && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="#" onClick={() => dispatch(abrirModalLogin())}>
                        <LoginSvg />
                        <span>Login e Cadastro</span>
                      </Link>
                    </MenuItem>
                  )}

                  {(!dadosLogin.data || (dadosLogin && dadosLogin.data && dadosLogin.data.anonimo && dadosLogin.data.anonimo !== 'naoanonimo')) && (getTotem() === 'true') && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="#" onClick={() => dispatch(abrirModalEscolhaLoginTotem())}>
                        <LoginSvg />
                        <span>Login e Cadastro</span>
                      </Link>
                    </MenuItem>
                  )}

                  <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                    <Link
                      // to="/" aqui é quando a tela inicial abria por padrão a ouvidoria. Agora a ouvidoria vai abrir somente na url "/ouvidoria" e não mais por padrão no inicio
                      to="/ouvidoria"
                      replace
                      onClick={() => { dispatch(desfazerSecretaria()); limpaLoginAnonimo(dadosLogin); }}
                    >
                      <OuvidoriaSvg />
                      <span>Ouvidoria</span>
                    </Link>
                  </MenuItem>

                  {dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppSic === 'S' && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="/sic" onClick={() => { dispatch(desfazerSecretaria()); limpaLoginAnonimo(dadosLogin); }}>
                        <SicSvg />
                        {dadosCidade.data.nomeCidade === 'São Sebastião' ? (
                          <span>SIC - Informação ao Cidadão</span>
                        ) : (
                          <span>Pedido de Informação (e-SIC)</span>
                        )}
                      </Link>
                    </MenuItem>
                  )}

                  {/* {(getIdCidadeEcrie() > 0) && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="/servicos" onClick={onClick}>
                        <ServicosSvg />
                        <span>Serviços</span>
                      </Link>
                    </MenuItem>
                  )} */}

                  {dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.OcultarAppZeladoria === 'S' && listaSecretariasZeladoria && listaSecretariasZeladoria.length > 0 && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link to="/zeladoria" onClick={() => { dispatch(desfazerSecretaria()); limpaLoginAnonimo(dadosLogin); }}>
                        <ZeladoriaSvg />
                        <span>Zeladoria</span>
                      </Link>
                    </MenuItem>
                  )}

                  {/* Botão comentado para facilitar a entrada no modo totem */}

                  {/* {(dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.Totem && dadosCidade.configuracoes.Totem === 'S') && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link
                        to=""
                        onClick={() => handleTotem()}
                      >
                        <TotemSvg width={60} height={60} style={{ width: 40, height: 40 }} />
                        <span>
                          {getTotem() === 'true' ? 'Sair do Totem' : 'Totem'}
                        </span>
                      </Link>
                    </MenuItem>
                  )} */}

                  {/* {(dadosLogin.data && dadosLogin.data.anonimo === 'naoanonimo' && getTotem() === 'true') && (
                  <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                    <Link
                      to="#"
                      onClick={() => {
                        dispatch(desfazerConexao());
                        // dispatch(desfazerCidade());
                        dispatch(desfazerSecretaria());
                        limpaLoginAnonimo(dadosLogin);
                        history.push('/');
                      }}
                    >
                      <LogoutSvg />
                      <span>{(dadosLogin.data) && ('Sair')}</span>
                    </Link>
                  </MenuItem>
                  )} */}

                  {(dadosLogin.data) && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link
                        to="#"
                        onClick={() => {
                          dispatch(desfazerConexao());
                          // dispatch(desfazerCidade());
                          dispatch(desfazerSecretaria());
                          limpaLoginAnonimo(dadosLogin);
                          history.push('/');
                        }}
                      >
                        <LogoutSvg />
                        <span>{(dadosLogin.data) && ('Sair')}</span>
                      </Link>
                    </MenuItem>
                  )}

                  {(getTotem() !== 'true') && (!dadosLogin.data) && (dadosCidade && dadosCidade.data && dadosCidade.data.nomeCidade && !dadosCidade.data.nomeCidade.toLowerCase().includes('cincatarina')) && (
                    <MenuItem totem={getTotem() === 'true'} tema={cor.graficos}>
                      <Link
                        to="#"
                        onClick={() => {
                          dispatch(desfazerConexao());
                          dispatch(desfazerCidade());
                          dispatch(desfazerSecretaria());
                          limpaLoginAnonimo(dadosLogin);
                          history.push('/');
                        }}
                      >
                        <LogoutSvg />
                        <span>Todas as cidades</span>
                      </Link>
                    </MenuItem>
                  )}

                </div>
              )}
            </>
          )}
          {/* <MenuFooter>
            <a href="https://www.webnets.com.br/" target="_blank" rel="noreferrer">
              <img src={LogoWebnets} alt="Logo da WebNets" />
            </a>
          </MenuFooter> */}

          {/* COMENTADO ABAIXO UM JEITO DIFERENTE DE MOSTRAR O ICONE PARA A CIDADE DE ITAPECERICA.
          O PROBLEMA DE IR ATRAVES DO "configuracoes" É QUE AO CLICAR EM "todas as cidades" ESTE ("configuracoes") NÃO É RESSETADO, E PORTANTO CONTINUAVA
          MOSTRANDO O ICONE QUE ERA PRA APARECER SOMENTE EM ITAPECERICA, MAS AGORA ESTAVA APARECENDO EM TODAS AS CIDADES.
          DITO ISSO, EU TROQUEI A LÓGICA PARA AO INVÉS DE TESTAR "configuracoes" (que não resseta), PASSARÁ A TESTAR PELA PROPRIEDADE "data".
          PARA ENTENDER MELHOR O CENÁRIO, COLOQUE UM "{console.log(dadosCidade)}" E FIQUE ENTRANDO E SAINDO DE UMA CIDADE PARA VER O
          COMPORTAMENTO DE "configuracoes" E DE "data" */}
          {/* {(dadosCidade && dadosCidade.configuracoes && dadosCidade.configuracoes.Cidade && dadosCidade.configuracoes.Cidade === 'Itapecerica da Serra') && ( */}

          {/* Agora a lógica do icone ficou dinâmica */}
          {(dadosCidade && dadosCidade.data && dadosCidade.configuracoes && dadosCidade.configuracoes.ParceiroLogo) && (
            <MenuFooter>
              {dadosCidade.configuracoes.ParceiroLogo.toLowerCase().includes('1doc') && (
                <a href="https://1doc.com.br" target="_blank" rel="noreferrer" title="1Doc">
                  <img src={Logo1Doc} alt="1Doc" style={{ width: 80, height: 'auto' }} />
                </a>
              )}
              {dadosCidade.configuracoes.ParceiroLogo.toLowerCase().includes('inter-tec') && (
                <a href="http://www.intertecsolucoes.com.br" target="_blank" rel="noreferrer" title="Inter-tec Soluções">
                  <img src={LogoInterTec} alt="Inter-Tec Soluções" style={{ width: 110, height: 'auto' }} />
                </a>
              )}
              {dadosCidade.configuracoes.ParceiroLogo.toLowerCase().includes('prescon') && (
                <a href="http://www.presconinformatica.com.br" target="_blank" rel="noreferrer" title="Prescon">
                  <img src={LogoPrescon} alt="Prescon - Informática Assessoria" style={{ width: 110, height: 'auto' }} />
                </a>
              )}
              {dadosCidade.configuracoes.ParceiroLogo.toLowerCase().includes('logo-el.png') && (
                <a href="https://www.el.com.br" target="_blank" rel="noreferrer" title="EL Produções de Software Ltda">
                  <img src={LogoEl} alt="EL Produções de Software Ltda" style={{ width: 95, height: 'auto' }} />
                </a>
              )}
            </MenuFooter>
          )}
        </Menu>
      </nav>
    </Header>
  );
};

AppHeader.propTypes = {
  onClick: PropTypes.func,
};

AppHeader.defaultProps = {
  onClick: null,
};

export default AppHeader;
